import React, { useState, useEffect } from 'react'
import { Form as Fomiker, Field as Fieldmik, Formik } from 'formik'
import { Form as FormUi, Segment, Container, Button, Input, Header, Dimmer, Loader, Icon } from 'semantic-ui-react'
import cogoToast from 'cogo-toast'
import { MyTextArea, MyNormalInput } from '../../apiInputComponent/myInput'
import AddTitleBar from '../../titleBar/add_titleBar'
import MyVehicleType from '../../apiInputComponent/myVehicleType'
import MyVendor from '../../apiInputComponent/myVendor'
import MyMake from '../../apiInputComponent/myMake'
import MyModel from '../../apiInputComponent/myModel'
import MyOwnership from '../../apiInputComponent/myOwnership'
import { DateData } from '../../apiInputComponent/dateData'
import MyInsuranceCompany from '../../apiInputComponent/myInsCompany'
import SerialNumber from '../../apiInputComponent/serialNumber'
import * as yup from 'yup';
import ReadAxios from '../../axiosComponent/read'
import VehicleEditTyreTable from './vehicleEditTyre'
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder'
import UpdateAxios from '../../axiosComponent/update'
import putAxios from '../../axiosComponent/put'
import patchAxios from '../../axiosComponent/patch'
import { object } from 'yup'
import EditSerialNumber from '../../apiInputComponent/editSerialNum'
import moment from 'moment';
import MyBranchAddVehicle from '../../apiInputComponent/myBranchAddVehicle'
import Axios from 'axios';
import APP_CONSTANTS from '../../../config/constants';
import BatterySerialNumber from './batterySerialNumber';
import ReactDatePicker from 'react-datepicker'
import { DATE_FORMATS, ERROR_MESSAGES } from '../../../utils/constants'
import { AllRegex } from '../../../utils/validation'

const FormikEditVehicle = (props) => {

  const [vehicleData, setvehicleData] = useState([])
  const [tyres, setTyres] = useState([])
  const [tyreData, setTyreData] = useState([])
  const [deletedTyreData, setDeletedTyreData] = useState([])
  const [delTyre, setdelTyre] = useState([])
  const [deleteBattery, setDeleteBattery] = useState([])
  const [tempArray , setTempArray] = useState([])
  let newArray = [];

  if (deletedTyreData.length > 0) {
    let uniqueObject = {};
    for (let i in deletedTyreData) {
      if (deletedTyreData[i]['isDeleted'] == 1) {
        let id = deletedTyreData[i]['tyreMapId']
        uniqueObject[id] = deletedTyreData[i]
      }
    }
    for (let i in uniqueObject) {
      newArray.push(uniqueObject[i])
    }
  }
  useEffect(() => {
    if (newArray.length > 0) {
      setdelTyre(newArray)
    }
  }, [newArray.length])
  const [batteryData, setBatteryData] = useState({})
  // console.log(batteryData,'batteryData')

  let getTyreData = (childData) => {
    console.log("------------")
    console.log(childData,'tyrData')
    setTyreData(childData)
  }

  let deleteTyreArray = (childData) => {
// console.log(childData,"aaaaaaaaaaaaaaaaaaa")
setTempArray(childData)
  }

  let getDeletedTyreData = (childData) => {
    // console.log("------------")
    // console.log(childData, "deleted tyre from child ")
    setDeletedTyreData(childData)
  }

  let deleteBatteryData = (values, index, setFieldValue) => {
    // console.log(data,'batteryDeleteData')
    let data = values.batteries[index]
    let deleteBatteryObj = deleteBattery
    deleteBatteryObj.push(data)
    setDeleteBattery(deleteBatteryObj)
    if (data.isDeleted == 1) {
      data.isDeleted = 0
      let batteryOpacity = values.batteryOpacity
      batteryOpacity[index] = false
      setFieldValue('batteryOpacity',batteryOpacity)
    } else {
      data.isDeleted = 1
      let batteryOpacity = values.batteryOpacity
      batteryOpacity[index] = true
      setFieldValue('batteryOpacity',batteryOpacity)
    }
  }

  useEffect(() => {
    let vId = props?.location?.state?.id

    // console.log("Recieved ViD", vId)

    let token = localStorage.getItem('apiToken')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNo')

    let vehicleData = {
      "userId": userId,
      "customerNumber": customerNo,
      "vehicleMasterId": vId
    }

    Axios.post(`${APP_CONSTANTS.BASE_URL}masters/vehicleMaster`, vehicleData, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token
      }
    }).then((response => {
      if (response?.data?.resultSet?.[0]?.vehicleMasterId) {
        getBatteryDetails(response.data.resultSet[0].vehicleMasterId, response.data.resultSet)
      }
    }))
      .catch(error => {
        console.log(error);
      })


  let getBatteryDetails = (vehicleIdReceived, vehicleDetails) => {
    let token = localStorage.getItem('apiToken')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNo')
    let data = JSON.stringify
      ({
        api_token: token,
        customerNumber: customerNo,
        userId: userId,
        checkDeletedRecord: 1
      })
    // console.log(APP_CONSTANTS)
    Axios.get(`${APP_CONSTANTS.BASE_URL}masters/vehicleBatteryMapping?userId=${userId}&customerNumber=${customerNo}&vehicleId=${vehicleIdReceived}`, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": localStorage.getItem('apiToken'),
        "Access-Control-Allow-Origin": "*"
      }
    }).then((response => {
      // console.log("(((((((((((((9999999)))))))))))")
      vehicleDetails.forEach(element => {
        element.batteries = response.data.resultSet.length > 0 && 
        response.data.resultSet.map((battery)=>{
          return ({
          batteryMapId : battery.batteryMapId,
          batterySerialNo : battery.batterySerialNo,
          batteryInstallationDate :  battery.batteryInstallationDate  && 
          battery.batteryInstallationDate != '00-00-0000 00:00' ?
            new Date(moment(battery.batteryInstallationDate.split(" ")[0], DATE_FORMATS.DATE_DDMMYYYY ||'DD-MM-YYYY')) : '',
          batteryAlreadyExist : true
          })
          })
      });
      // console.log(vehicleDetails)
      // console.log(response.data.resultSet[0])
      if(response){
        setBatteryData(response.data.resultSet[0])
        setvehicleData(vehicleDetails);
        setTyres(response.data.resultSet);
      }   
    }))
      .catch(error => {
        setvehicleData(vehicleDetails);
        setTyres(vehicleDetails);
        console.log(error)
      })
  }
}, [])

  if (vehicleData.length === 0 ) {
    return (
      <>
        <AddTitleBar Title="Edit Vehicle" LinkName="/vehicle" />
        <LoadingPlaceholder />
      </>
    )
  } else {
    let updatedParams = (data) => {
      return data.map((object, idx) => {
        return {
          positionId: object.position,
          tyrePostionName: object.tyrePostionName,
          serialNo: object.serialNo,
          tyreMapId: object.tyreMapId,
          tyrePositionId: object.tyrePositionId,
          installationDate: object.installationDate,
          tyreRun: object.tyreRun,
        }
      })
    }
    let updatedVehicleParams = (data) => {
      return data.map((object, idx) => {
        return {
          positionId: parseInt(object.tyrePositionId),
          serialNo: object.serialNo,
          tyreMapId: object.tyreMapId,
          tyrePostionName: object.tyrePostionName,
          position: object.tyrePostionName,
          tyrePositionId: object.tyrePositionId,
          installationDate: object.installationDate,
          tyreRun: object.tyreRun,

        }
      })
    }
    const validSchema = yup.object({
      vehicleNumber: yup.string().matches(AllRegex.VehicleNumber, ERROR_MESSAGES.INVALID_VEHICLE_NO||'Invalid Vehicle Number').required(ERROR_MESSAGES.REQUIRED ||'Required'),
      vehicleTypeId: yup.string().required(ERROR_MESSAGES.REQUIRED||'Required'),
      branchId: yup.string().required(ERROR_MESSAGES.REQUIRED||'Required').nullable(),
      vehicleOwnershipId: yup.string().required(ERROR_MESSAGES.REQUIRED||'Required'),
      engineNo: yup.string().matches(AllRegex.engineNo, ERROR_MESSAGES.INVALID_FORMAT||"Invalid Format").max(50, ERROR_MESSAGES.LESS_THAN_CHARECTERS(50)||'Must be less than 50 characters'),
      chassisNo: yup.string().matches(AllRegex.chasisNo, ERROR_MESSAGES.INVALID_FORMAT||"Invalid Format").max(50, ERROR_MESSAGES.LESS_THAN_CHARECTERS(50)||'Must be less than 50 characters'),
      insPolicyNo: yup.string().matches(AllRegex.insurancePolicyNo, ERROR_MESSAGES.INVALID_FORMAT||"Invalid Format").max(50, ERROR_MESSAGES.LESS_THAN_CHARECTERS(50)||'Must be less than 50 characters'),
      fuelTankCapacity: yup.number().min(0, ERROR_MESSAGES.MUST_BE_POSITIVE_NO||'Must be a Valid Positive Number').max(100000000, 'Must be less then 10000000').optional(),
      valueOfInsurance: yup.number().integer(ERROR_MESSAGES.INS_VALUE||'Insurance Value must be whole number').min(1, ERROR_MESSAGES.MUST_BE_POSITIVE_NO||'Must be a Valid Positive Number').max(100000000, ERROR_MESSAGES.LESS_THAN(100000000)||'Must be less than 1000000000').optional().nullable(),
      insPremium: yup.number().integer(ERROR_MESSAGES.INS_PREMIUM||'Insurance Premium must be whole number').min(1, ERROR_MESSAGES.MUST_BE_POSITIVE_NO||'Must be a Valid Positive Number').max(100000000, ERROR_MESSAGES.LESS_THAN(100000000)||'Must be less than 1000000000').optional().nullable(),
    })

    let finalVehicleMapping = (vehicleIDFetched, tyreDetails) => {
      let addTyresToVehicle = []
      let deleteTyresToVehicle = []
      let deletedTyreDetails = delTyre.filter((tyre)=> tyre.serialNo)
      setdelTyre(deletedTyreDetails)
      tyreDetails.forEach((element) => {
        //console.log(element, "element")
        if (element?.serialNo || element?.tyreRun || element?.installationDate && element.flag != 0) {
          let temp = {};
          let demapTemp = {};
          temp.tyreMapId = element?.tyreMapId ? element.tyreMapId : 0
          demapTemp.tyreMapId = element.tyreMapId
          temp.vehicleId = vehicleIDFetched
          demapTemp.vehicleId = vehicleIDFetched

          temp.tyreRun = element.tyreRun
          demapTemp.tyreRun = element.tyreRun
          temp.installationDate = moment(element.installationDate).format(DATE_FORMATS.DATE_YYYYMMDD || 'YYYY-MM-DD')
          demapTemp.installationDate = moment(element.installationDate).format(DATE_FORMATS.DATE_YYYYMMDD ||'YYYY-MM-DD')

          temp.tyrePositionId = String(element.positionId)
          demapTemp.tyrePositionId = String(element.positionId)
          if (element?.serialNoPrev) {
            if (element.serialNoPrev.localeCompare(element.serialNo) != 0) {
              demapTemp.serialNo = element.serialNoPrev
              deleteTyresToVehicle.push(demapTemp)
            }
          }
          temp.serialNo = element.serialNo
          addTyresToVehicle.push(temp)
        }
      })
      if (addTyresToVehicle && addTyresToVehicle?.length > 0  || deletedTyreData && deletedTyreData?.length > 0) {
        putAxios({
          url: 'masters/vehicleTyreMapping',
          createItems: { mergeTyreMapping: deletedTyreDetails.length>0 ? tempArray : addTyresToVehicle, deleteTyreMapping: deletedTyreDetails.length > 0 ? deletedTyreDetails : deleteTyresToVehicle },
        })
          .then(result => {
            /* result.data.resultSet.forEach(element => {
              element.mergeTyreMapping.message.success.forEach(item => {
                cogoToast.success(item, { hideAfter: '5' })
              })
            }); */
            // cogoToast.success("Updated tyre data successfully!!!", { hideAfter: '5' })
            //window.location.href = '/vehicle'
          })
          .catch((err) => {
            cogoToast.error("Error while updating tyre data...", { hideAfter: '5' })
            console.log(err)
          })
      }
    }

    const addBattery = (values, setFieldValue)=>{
      let batteries = values.batteries
      batteries.push({
        batterySerialNo: '',
        batteryInstallationDate: '',
      })
      setFieldValue('batteries', batteries)
    }
    const removeBattery = (index, values, setFieldValue)=>{
      let batteries = values.batteries
      batteries.splice(index,1)
      setFieldValue('batteries', batteries)
    }

    let finalBatteryMapping = (vehicleIDFetched, values) => {
      let batteryMappingData = []
      let batteryDemappingData = []

      let Batteries = values.batteries
      if(deleteBattery.length > 0){
        deleteBattery.map((battery)=>{
          let batteryDemapData = {}
          batteryDemapData.batteryMapId =  battery.batteryMapId
          batteryDemapData.vehicleId = vehicleIDFetched
          batteryDemapData.isDeleted = 1
          batteryDemapData.batterySerialNo = battery.batterySerialNo
          Batteries = Batteries.length > 0 && Batteries.filter((batteryObj)=> batteryObj?.batterySerialNo !== battery.batterySerialNo)
          batteryDemappingData.push(batteryDemapData)
        })
      }
      
      Batteries.length > 0 &&
      Batteries.map((battery)=>{
          let batteryDetailData = {}
          batteryDetailData.batteryMapId = battery.batteryMapId || 0
          batteryDetailData.vehicleId = vehicleIDFetched
          batteryDetailData.isDeleted = 0
          batteryDetailData.batteryConsumption = 0
          batteryDetailData.batteryInstallationDate = moment(battery.batteryInstallationDate).format(DATE_FORMATS.DATE_YYYYMMDD ||'YYYY-MM-DD')
          batteryDetailData.batterySerialNo = battery?.batterySerialNo?.serialNo ? battery.batterySerialNo.serialNo : battery.batterySerialNo
          batteryMappingData.push(batteryDetailData)
        })
      putAxios({
        url: 'masters/vehicleBatteryMapping',
        createItems: { mergeBatteryMapping: batteryMappingData , deleteBatteryMapping: batteryDemappingData},
      })
        .then((result) => {
          /* result.data.resultSet.forEach(element => {
            element.mergeTyreMapping.message.success.forEach(item => {
              cogoToast.success(item, { hideAfter: '5' })
            })
          }); */
          // cogoToast.success("Updated battery data successfully!!!", { hideAfter: '5' })
          //window.location.href = '/vehicle'
        })
        .catch((err) => {
          cogoToast.error("Error while updating battery data...", { hideAfter: '5' })
          console.log(err)
        })
    }

    return (
      <>
        <AddTitleBar Title="Edit Vehicle" LinkName="/vehicle" />
        <Container fluid className="m-2">
          {/* {console.log("vehicleDatavehicleDatavehicleDatavehicleDatavehicleDatavehicleData")}
          {console.log(vehicleData[0].manufactureDate)} */}
          <Formik
            initialValues={{
              vehicleId: vehicleData?.[0]?.vehicleMasterId ? vehicleData[0].vehicleMasterId : '',
              id: vehicleData?.[0]?.vehicleMasterId ? vehicleData[0].vehicleMasterId : '',
              vehicleNumber: vehicleData?.[0]?.vehicleNumber ? vehicleData[0].vehicleNumber : '',
              vehicleCode: vehicleData?.[0]?.vehicleCode ? vehicleData[0].vehicleCode : '',
              makeId: vehicleData?.[0]?.makeId ? vehicleData[0].makeId : '',
              modelId: vehicleData?.[0]?.vehicleModel ? vehicleData[0].vehicleModel : '',
              vehicleTypeId: vehicleData?.[0]?.vehicleTypeMasterId ? vehicleData[0].vehicleTypeMasterId : '',
              manufactureDate: vehicleData?.[0]?.manufactureDate != null && vehicleData?.[0]?.manufactureDate != "00-00-0000" ?  new Date(moment(vehicleData[0].manufactureDate.split(" ")[0], DATE_FORMATS.DATE_DDMMYYYY ||'DD-MM-YYYY')): '',
        //       requested_pickup_date: values?.deliveries?.[0]?.requested_pickup_date ?
        // moment(values.deliveries[0].requested_pickup_date, 'YYYY-MM-DD HH:mm')
        // : "",
              branchId: vehicleData?.[0]?.branchId ? vehicleData[0].branchId : null,
              purchaseDate: vehicleData?.[0]?.purchaseDate != null && vehicleData?.[0]?.purchaseDate != "00-00-0000" ?  new Date(moment(vehicleData[0].purchaseDate.split(" ")[0], DATE_FORMATS.DATE_DDMMYYYY ||'DD-MM-YYYY')) : '',
              regDate: vehicleData?.[0]?.regDate != null && vehicleData?.[0]?.regDate != "00-00-0000" ?  new Date(moment(vehicleData[0].regDate.split(" ")[0], DATE_FORMATS.DATE_DDMMYYYY ||'DD-MM-YYYY')) : '',
              branchName: '',
              fuelTankCapacity: vehicleData?.[0]?.fuelTankCapacity ? vehicleData[0].fuelTankCapacity : '',
              rtoLocation: vehicleData?.[0]?.rtoLocation ? vehicleData[0].rtoLocation : '',
              engineNo: vehicleData?.[0]?.engineNo ? vehicleData[0].engineNo?.toUpperCase() : '',
              chassisNo: vehicleData?.[0]?.chassisNo ? vehicleData[0].chassisNo?.toUpperCase() : '',
              transporterId: vehicleData?.[0]?.transporterId ? vehicleData[0].transporterId : '',
              vendorName: vehicleData?.[0]?.transporterName ? vehicleData[0].transporterName : '',
              vehicleOwner: vehicleData[0].vehicleOwner,
              vehicleOwnershipId: vehicleData[0].vehicleOwner === 'Owned' ? 1 : 2,
              batteries : vehicleData[0].batteries?.length > 0 ? vehicleData[0].batteries : [{
                batterySerialNo: '',
                batteryInstallationDate: '',
              }],
              insCompanyId: vehicleData?.[0]?.insCompanyId ? vehicleData[0].insCompanyId : '',
              valueOfInsurance: vehicleData?.[0]?.valueOfInsurance ? vehicleData[0].valueOfInsurance : '',
              insPremium: vehicleData?.[0]?.insPremium ? vehicleData[0].insPremium : '',
              insPlaceOfClain: vehicleData?.[0]?.insPlaceOfClain ? vehicleData[0].insPlaceOfClain : '',
              insVendorId: vehicleData?.[0]?.insVendorId ? vehicleData[0].insVendorId : '',
              insPolicyNo: vehicleData?.[0]?.insPolicyNo ? vehicleData[0].insPolicyNo?.toUpperCase() : '',
              insNote: vehicleData?.[0]?.insNote ? vehicleData[0].insNote : '',
              batteryOpacity: {}
              // vehicleTyres: updatedVehicleParams(vehicleData.vehicle_tyre),
              // oldVehicleTyres: updatedParams(tyres.vehicle_tyre),
              // oldVehicleTyres: tyres.vehicle_tyre,
            }}
            validationSchema={validSchema}
            onSubmit={(values, { setSubmitting }) => {
              ///onsole.log(values, "valuessssssss")
              setSubmitting(true)

              let batteryInstallationDate = moment(values.batteryInstallationDate).format(DATE_FORMATS.DATE_DDMMYYYY ||'DD-MM-YYYY')

              let finval = { ...values }

              let VehicleData = {
                vehicleNumber: values.vehicleNumber,
                vehicleCode: values.vehicleCode,
                vehicleTypeId: values.vehicleTypeId,
                makeId: values.makeId,
                modelId: values.modelId,
                manufactureDate:moment( values.manufactureDate).format(DATE_FORMATS.DATE_YYYYMMDD ||'YYYY-MM-DD'),
                branchId: values.branchId,
                purchaseDate: moment(values.purchaseDate).format(DATE_FORMATS.DATE_YYYYMMDD ||'YYYY-MM-DD'),
                regDate: moment(values.regDate).format(DATE_FORMATS.DATE_YYYYMMDD ||'YYYY-MM-DD'),
                fuelTankCapacity: values.fuelTankCapacity,
                rtoLocation: values.rtoLocation,
                engineNo: values.engineNo.toUpperCase(),
                chassisNo: values.chassisNo.toUpperCase(),
                transporterId: values.transporterId,
                vehicleOwner: values.vehicleOwner,
                //batterySerialNo: values.batterySerialNo.serialNo,
                //batteryInstallationDate: values.batteryInstallationDate ? moment(values.batteryInstallationDate).format('DD-MM-YYYY') : '',
                //batteryConsumption: values.batteryConsumption,
                insCompanyId: values.insCompanyId,
                valueOfInsurance: values.valueOfInsurance,
                insPremium: values.insPremium,
                insPlaceOfClain: values.insPlaceOfClain,
                insVendorId: values.insVendorId,
                insPolicyNo: values.insPolicyNo.toUpperCase(),
                insNote: values.insNote,
              }

              patchAxios({
                url: `masters/vehicleMaster/${values.id}`,
                createItems: VehicleData,
              })
                .then(async(response) => {
                  if (response.data.status == 200 || response.data.status == 201 || response.data.status == 1) {
                    cogoToast.success(response.data.message)
                    setInterval(() => {
                      window.location.href = '/vehicle'
                    }, 3000);
                    let vehicleIDFetched = values.id
                    //Battery
                    if(values.batteries.length > 0){
                      let batteries = values.batteries.filter((battery)=> battery?.batterySerialNo?.serialNo || battery?.batterySerialNo)
                      values.batteries = batteries
                      let newBatteries = values.batteries.filter((battery)=> battery?.batterySerialNo?.serialNo)
                      let successfullBatteries = []
                      if(newBatteries.length > 0){
                        await Promise.all(newBatteries.map(async (battery)=>{
                          if (battery?.batterySerialNo?.productInventoryId == 0) {
                            let batteryInsertData = {
                              "batterySerialNo": battery.batterySerialNo.serialNo,
                              "batteryCode": battery.batterySerialNo.serialNo,
                              "batteryStatusId": 1,
                            }
                            try{
                              let batteryResponse = await putAxios({
                              url: 'masters/battery',
                              createItems: batteryInsertData,
                            })
                            if(batteryResponse.data.status == 200){
                              successfullBatteries.push(battery)
                            }else{
                              cogoToast.error(`Error while creating battery (${battery?.batterySerialNo?.serialNo}) - ${batteryResponse?.data?.message}`)
                            }
                           }catch(err){
                            console.log(err);
                           }  
                          }
                        })).then(()=>{
                          values.batteries = successfullBatteries
                          finalBatteryMapping(vehicleIDFetched, values)
                        }).catch((err)=>{
                          values.batteries = successfullBatteries
                          console.log(err);
                          finalBatteryMapping(vehicleIDFetched, values)
                        })

                      }else{
                        finalBatteryMapping(vehicleIDFetched, values)
                      }
                    }
                    

                    //tyreData
                    let tyre_data = tyreData.filter((tyre)=> tyre.serialNo)
                    let successfull_tyres = []
                    let calulatedItr = 0;
                    await Promise.all(tyre_data.map(async (element, index) => {
                      if (element?.productInventoryId == 0) {
                        let tyreInsertData = {
                          "serialNo": element.serialNo,
                          "tyreCode": element.serialNo,
                          "tyrePositionId": element.positionId,
                          "tyreStatusId": 1,
                          "tyreRun": element.tyreRun,
                        }

                        try{
                          let tyreAddResponse = await putAxios({
                          url: 'masters/tyre',
                          createItems: tyreInsertData,
                        })
                            if(tyreAddResponse.data.status === 200){
                              successfull_tyres.push(element)
                            }else{
                              cogoToast.error(tyreAddResponse.data.message)
                            }   
                          }catch(err){
                            console.log(err);
                          } 
                      }else{
                        successfull_tyres.push(element)
                      }
                    })).then(()=>{
                      finalVehicleMapping(vehicleIDFetched, successfull_tyres)
                    }).catch((err)=>{
                      console.log(err)
                      finalVehicleMapping(vehicleIDFetched, successfull_tyres)
                    })
                  } else {
                    setSubmitting(false)
                  }
                })
                .catch((err) => {
                  cogoToast.error("Error while updating data...", { hideAfter: '5' })
                  setSubmitting(false)
                })
            }}
            render={({ touched, errors, values,setFieldValue, isSubmitting, handleSubmit }) => {
              {console.log(values,'valuessssss')}

              let getData = (data) => {
                values.vehicleTyres = data
                // console.log('--->Updated', tyres)
              }
              let getRows = (data, vehicleId) => {
                if (data) {
                  return (
                    <VehicleEditTyreTable id={data} vehicleId={vehicleId} deleteTyreArray={deleteTyreArray} tyrData={getTyreData} deletedTyre={getDeletedTyreData} oldStoredTyres={values.oldVehicleTyres} storedTyre={values.vehicleTyres} />
                  )
                }
              }

              return (
                <Fomiker>
                  <Dimmer inverted active={isSubmitting}>
                    <Loader>Loading...</Loader>
                  </Dimmer>
                  <Segment>
                    <div className="ui form tiny">
                      <Header color="blue" size="tiny" className="labelName p-bold-500">Basic Details</Header>
                      <FormUi.Group inline={touched.vehicleNumber && errors.vehicleNumber ? false : touched.vehicleTypeId && errors.vehicleTypeId ? false : true}>
                        <FormUi.Field width="4">
                          <label className="labelName">Vehicle Number *</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik component={MyNormalInput} name="vehicleNumber" />
                          {touched.vehicleNumber && errors.vehicleNumber ? <div className="w3-text-red w3-tiny p-bold-600">{errors.vehicleNumber}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Vehicle Type*</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik component={MyVehicleType} value={values.vehicleTypeId} name="vehicleTypeId" disabled={true} clearable={false} />
                          {touched.vehicleTypeId && errors.vehicleTypeId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.vehicleTypeId}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline>
                        <FormUi.Field width="4">
                          <label className="labelName">Make</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik component={MyMake} value={values.makeId} name="makeId" placeholder="Make" />
                          {touched.makeId && errors.makeId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.makeId}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Model</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik component={MyModel} dataId={values.makeId} value={values.modelId} name="modelId" placeholder={values.models} />
                          {touched.modelId && errors.modelId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.modelId}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline>
                        <FormUi.Field width="4">
                          <label className="labelName">Manufacturing Date</label>
                        </FormUi.Field>
                        <FormUi.Field className='datepic' width="3">
                          {/* {values.manufactureDate} */}
                          <DateData
                            name="manufactureDate"
                            popperClassName="date"
                            dateFormat="dd-MM-yyyy"
                            selected={ new Date(values.manufactureDate)}
                            customInput={<Input value={(values.manufactureDate)} icon="time" iconPosition="left" />}
                          /> 
                          {touched.manufactureDate && errors.manufactureDate ? <div className="w3-text-red w3-tiny p-bold-600">{errors.manufactureDate}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Branch*</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik component={MyBranchAddVehicle} className="p-placeholder" name="branchId" value={values.branchId} />
                          {touched.branchId && errors.branchId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.branchId}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline>
                        <FormUi.Field width="4">
                          <label className="labelName">Purchase Date</label>
                        </FormUi.Field>
                        <FormUi.Field className='datepic' width="3">
                          {/* <DateData
                            name="purchaseDate"
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat="dd/MM/yyyy"
                            selected={new Date(values.purchaseDate)}
                            customInput={<Input icon="time" value={new Date(values.purchaseDate)} iconPosition="left" />}
                          /> */}
                           <DateData
                            name="purchaseDate"
                            popperClassName="date"
                            dateFormat={DATE_FORMATS.DATE_ddMMYYYY ||"dd-MM-yyyy"}
                            selected={ new Date(values.purchaseDate)}
                            customInput={<Input value={(values.purchaseDate)} icon="time" iconPosition="left" />}
                          /> 
                          {touched.purchaseDate && errors.purchaseDate ? <div className="w3-text-red w3-tiny p-bold-600">{errors.purchaseDate}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Registration Date</label>
                        </FormUi.Field>
                        <FormUi.Field className='datepic' width="3">
                          <DateData
                            name="regDate"
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS.DATE_ddMMYYYY ||"dd-MM-yyyy"}
                            selected={new Date(values.regDate)}
                            // placeholderText={new Date(values.regdate)}
                            customInput={<Input icon="time" iconPosition="left" />}
                          />
                          {touched.regDate && errors.regDate ? <div className="w3-text-red w3-tiny p-bold-600">{errors.regDate}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline={touched.fuelTankCapacity && errors.fuelTankCapacity ? false : true}>
                        <FormUi.Field width="4">
                          <label className="labelName">Fuel Tank Capacity (In Liters)</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik type="number" min="0" component={MyNormalInput} name="fuelTankCapacity" />
                          {touched.fuelTankCapacity && errors.fuelTankCapacity ? <div className="w3-text-red w3-tiny p-bold-600">{errors.fuelTankCapacity}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName ml-1">RTO Location</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik component={MyNormalInput} name="rtoLocation" />
                          {touched.rtoLocation && errors.rtoLocation ? <div className="w3-text-red w3-tiny p-bold-600">{errors.rtoLocation}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline>
                        <FormUi.Field width="4">
                          <label className="labelName ">Engine No.</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik component={MyNormalInput} name="engineNo" placeholder={values.engineNos} />
                          {touched.engineNo && errors.engineNo ? <div className="w3-text-red w3-tiny p-bold-600">{errors.engineNo}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName ml-1">Chassis No.</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik component={MyNormalInput} name="chassisNo" placeholder={values.chassisNos} />
                          {touched.chassisNo && errors.chassisNo ? <div className="w3-text-red w3-tiny p-bold-600">{errors.chassisNo}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline>
                        <FormUi.Field width="4">
                          <label className="labelName">Vendor</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik component={MyVendor} wrapSelection className="p-placeholder" placeholder={values.vendorName} name="transporterId" defaultSearchQuery={values.vendorName} />
                          {touched.transporterId && errors.transporterId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.transporterId}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName ml-1">Vehicle Ownership</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik component={MyOwnership} value={values.vehicleOwnershipId} name="vehicleOwnershipId" nameText="vehicleOwner" />
                          {touched.vehicleOwnershipId && errors.vehicleOwnershipId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.vehicleOwnershipId}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>

                    </div>
                  </Segment>
                  {getRows(values.vehicleTypeId, values.vehicleId)}
                  {/* {console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF")}
                  {console.log(values)} */}
                  <Segment >
                    <div className="ui form tiny">
                    <div className='d-flex mb-2'>
                      <Header color="blue" size="tiny" className="labelName p-bold-500">Battery Details</Header>
                      <Button size="tiny" type="button" className='ml-auto w3-tiny' primary onClick={()=>addBattery(values,setFieldValue)}><Icon name="plus" /> Add Battery</Button>
                      </div>
                      {values.batteries.length > 0  && 
                      values.batteries.map((battery, index)=>
                      <FormUi.Group inline className={values.batteryOpacity && values.batteryOpacity[index] == true ? 'opacityBlurr' : ''}>
                        <FormUi.Field width="4">
                          <label className="labelName">Battery Serial No.</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          {/* {values.batterySrNo} */}
                          <Fieldmik component={BatterySerialNumber} batteryData={battery.batterySerialNo}  /*disabled ={battery.batterySerialNo && battery.batteryInstallationDate } defaultValue={object.batterySerialNo} */ placeholder={battery.batterySerialNo} className="p-placeholder" /* defaultSearchQuery={values.batterySerialNo} */ /* TyreId="0" */ name={`batteries[${index}].batterySerialNo`} />
                          {touched.batterySerialNo && errors.batterySerialNo ? <div className="w3-text-red w3-tiny p-bold-600">{errors.batterySerialNo}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Battery Installation Date</label>
                        </FormUi.Field>
                        <FormUi.Field className="datepic" width="3">
                          <DateData
                            name={`batteries[${index}].batteryInstallationDate`}
                            autoComplete="off"
                            //disabled ={battery.batterySerialNo && battery.batteryInstallationDate }
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS.DATE_ddMMYYYY ||"dd-MM-yyyy"}
                            selected={new Date(battery.batteryInstallationDate)}
                            customInput={<Input icon="time" iconPosition="left" />}
                          />
                          {touched.batteryDate && errors.batteryDate ? <div className="w3-text-red w3-tiny p-bold-600">{errors.batteryDate}</div> : ''}
                        </FormUi.Field>
                        {battery.batterySerialNo && <FormUi.Field>
                          <Icon name='trash' className='mt-10' color="red"
                            onClick={(e) => {
                              e.stopPropagation();
                              deleteBatteryData(values,index, setFieldValue)
                            }}
                          />
                        </FormUi.Field>}
                        {index > 0 && !battery.batteryAlreadyExist && <Icon name="remove" className='ml-auto' color='red' onClick={()=>removeBattery(index,values,setFieldValue)}/>}
                      </FormUi.Group>
                      )}
                    </div>
                  </Segment>
                  <Segment>
                    <div className="ui form tiny">
                      <Header color="blue" size="tiny" className="labelName p-bold-500">Insurance Details</Header>
                      <FormUi.Group inline={touched.valueOfInsurance && errors.valueOfInsurance ? false : true}>
                        <FormUi.Field width="4">
                          <label className="labelName">Insurance Company</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik component={MyInsuranceCompany} value={values.insCompanyId} name="insCompanyId" placeholder="" />
                          {touched.insCompanyId && errors.insCompanyId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.insCompanyId}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Value of Insurance</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik type="number" min="0" component={MyNormalInput} value={values.valueOfInsurance} name="valueOfInsurance" placeholder="" />
                          {touched.valueOfInsurance && errors.valueOfInsurance ? <div className="w3-text-red w3-tiny p-bold-600">{errors.valueOfInsurance}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline={touched.insPremium && errors.insPremium ? false : true}>
                        <FormUi.Field width="4">
                          <label className="labelName">Premium</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik type="number" min="0" component={MyNormalInput} name="insPremium" placeholder="" />
                          {touched.insPremium && errors.insPremium ? <div className="w3-text-red w3-tiny p-bold-600">{errors.insPremium}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Place of Claim</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik component={MyNormalInput} name="insPlaceOfClain" placeholder="" />
                          {touched.insPlaceOfClain && errors.insPlaceOfClain ? <div className="w3-text-red w3-tiny p-bold-600">{errors.insPlaceOfClain}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline>
                        <FormUi.Field width="4">
                          <label className="labelName">Insurance Vendor</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik component={MyVendor} wrapSelection className="p-placeholder" placeholder={values.insVendorId} name="insVendorId" value={values.insVendorId} />
                          {touched.insVendorId && errors.insVendorId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.insVendorId}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Policy Number</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik component={MyNormalInput} name="insPolicyNo" placeholder="Number" />
                          {touched.insPolicyNo && errors.insPolicyNo ? <div className="w3-text-red w3-tiny p-bold-600">{errors.insPolicyNo}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                    </div>
                  </Segment>
                  <Segment>
                    <div className="ui form">
                      <FormUi.Group>
                        <FormUi.Field width="6">
                          <label className="labelName">Notes</label>
                          <Fieldmik component={MyTextArea} name="insNote" placeholder="Enter Notes" />
                          {touched.insNote && errors.insNote ? <div className="w3-text-red w3-tiny p-bold-600">{errors.insNote}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                    </div>
                  </Segment>
                  <center><Button disabled={isSubmitting} onClick={handleSubmit} size="mini" primary type="submit">Submit</Button></center>
                </Fomiker>
              )
            }}
          />
        </Container>
      </>
    )
  }


}


export default FormikEditVehicle
